import { Component } from '@angular/core';
import { NavController, NavParams, Platform, ModalController } from 'ionic-angular';
import { AbstractPage } from '../../_com/abstract-page';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { CallNumber } from '@ionic-native/call-number';
import { ReserveEditPage } from '../../reserve/edit/reserve-edit';
import { ChildDetailPage } from '../../child/detail/child-detail';
import { ChildEditPage } from '../../child/edit/child-edit';
import { FamilyEditPage } from '../../family/edit/family-edit';
import { BasicState } from '../../../states/basic-state';
import { HttpFamilyProvider } from '../../../providers/http-family';
import { Subscription } from 'rxjs/Subscription';

/**
 * Generated class for the FamilyDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-family-detail',
  templateUrl: 'family-detail.html',
})
export class FamilyDetailPage extends AbstractPage{

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private pl:PhotoLibrary, 
    private pv:PhotoViewer, 
    private plt:Platform, 
    private callNumber:CallNumber,
    private modalController:ModalController, 
    private basicState:BasicState, 
    private httpFamilyProvider:HttpFamilyProvider) {
    super();
    this.pv; //for TSLint
    this.pl; //for TSLint
    this.plt; //for TSLint
    this.callNumber;  //for TSLint

    /**
     * 子供情報が更新されたイベント
     */
    this.onChangeChildDetail = this.basicState.onChangeChildDetail.subscribe((data)=>{
      this.refresh();
    })

    /**
     * 親情報が更新されたイベント
     */
     this.onChangeFamilyDetail = this.basicState.onChangeFamilyDetail.subscribe((date)=>{
        this.refresh();
     })
  }

  data = {};
  onChangeChildDetail:Subscription;
  onChangeFamilyDetail:Subscription;

  ionViewDidLoad() {
    this.data = this.navParams.data["Family"];
  }

  /**
   * データリフレッシュ
   */
  refresh(){

    this.httpFamilyProvider.getList({id:this.data["id"]}).subscribe((data)=>{
      if(data.length = 1){
        this.data = data.data[0]["Family"];
      }
    });
  }

  /**
   * 予約画面起動
   */
  openReserveEdit(){

    var data = {family:this.data};
    let modal = this.modalController.create(ReserveEditPage, data, {enableBackdropDismiss:false});
    modal.present();
  }

  /**
   * 子供詳細画面へ遷移
   */
  goChild(e, child){

    if(e.target.className != "button-inner"){
      this.navCtrl.push(ChildDetailPage, {child:child, family:this.data});
    }
  }

  /**
   * 保護者情報編集
   */
  edit(){
    var p = {
      family:this.data
    };
    this.navCtrl.push(FamilyEditPage, p);
  }

 /**
   * subscription破棄
   */
  ngOnDestroy(){
    this.onChangeChildDetail.unsubscribe();
    this.onChangeFamilyDetail.unsubscribe();
  }

  /**
   * 子供を追加する
   */
  addChild() {
    this.navCtrl.push(ChildEditPage, { family: this.data });
  }
}


// WEBPACK FOOTER //
// ./src/pages/family/detail/family-detail.ts